import { render, staticRenderFns } from "./LackAccountDialog.vue?vue&type=template&id=606ce2ba&scoped=true"
import script from "./LackAccountDialog.vue?vue&type=script&lang=js"
export * from "./LackAccountDialog.vue?vue&type=script&lang=js"
import style0 from "./LackAccountDialog.vue?vue&type=style&index=0&id=606ce2ba&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606ce2ba",
  null
  
)

export default component.exports